import ImportUsers from "./components/templates/ImportUsers.vue"

export default {
    install(app) {
        app.component('ImportUsers', ImportUsers);
    }
};
